import React from "react";
import ModalBaseView from "../../../../../../common-deprecated/components/modals/aem/ModalBaseView";
import * as Modal from "../../../../../../common-deprecated/styles/v2/toyota/globals/Modal";
import * as Button from "../../../../../../common-deprecated/styles/v2/toyota/components/Button";
import * as Type from "../../../../../../common-deprecated/styles/v2/toyota/globals/Type";
import Icon from "../../../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import { IconWrapper } from "../../../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import { NavStep } from "../../../../shared-logic/utils/Navigation";
import useStepUrl from "../../../hooks/shared/actions/useStepUrl";
import { BnbLabel } from "../../../utils/labels";
import type { ExitPassiveSummaryModalType } from "../../../utils/modalConstants";
import type { ModalViewType } from "../../../../../../common-deprecated/types/CommonTypes";
import { useCommonLabel } from "../../../../../../common-deprecated/utils/commonLabels";

const ExitPassiveSummaryModal = (props: ModalViewType<ExitPassiveSummaryModalType>): JSX.Element => {
    const { show, close, modalSettings } = props;
    const customizeURL = useStepUrl(NavStep.Customize).href;

    const closeLabel = useCommonLabel("close");

    return (
        <ModalBaseView modalIdType={modalSettings.type} onClose={close} show={show} size="md">
            <Modal.Header>
                <Modal.Title>
                    <BnbLabel label="passiveSummaryChangeModalTitle" />
                </Modal.Title>
                <Modal.Button type="button" aria-label={closeLabel} onClick={close}>
                    <IconWrapper aria-hidden="true">
                        <Icon variant="close" />
                    </IconWrapper>
                </Modal.Button>
            </Modal.Header>
            <Modal.Body>
                <Type.Text>
                    <BnbLabel label="passiveSummaryWarning" />
                </Type.Text>
            </Modal.Body>
            <Modal.Actions>
                <Button.Secondary onClick={close}>
                    <BnbLabel label="passiveSummaryCancelEditConfiguration" />
                </Button.Secondary>
                <Button.Primary as="a" href={customizeURL}>
                    <BnbLabel label="passiveSummaryEditConfiguration" />
                </Button.Primary>
            </Modal.Actions>
        </ModalBaseView>
    );
};

export default ExitPassiveSummaryModal;
